import * as React from 'react';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import Checkbox from '@material-ui/core/Checkbox';
// import Link from '@material-ui/core/Link';
import Grid from '@material-ui/core/Grid';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import { Hidden } from '@material-ui/core';
import { Link } from 'react-router-dom';
// import Avatar from '@material-ui/core/Avatar';
// import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
// import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
// import countries from '../signup/CountrySelect';
import Header from '../layouts/Header';
// import TextareaAutosize from '@material-ui/core/TextareaAutosize';

export interface SignUpPageViewProps {
  saveCustomerName: (customername: string) => void;
  saveCustomerType: (customerType: string) => void;
  saveFirstname: (customerFirstName: string) => void;
  saveLastname: (customerLastName: string) => void;
  saveEmail: (customerEmail: string) => void;
  // savePhonenumber: (customerNumber: string) => void;
  saveAddressOne: (customerAddressOne: string) => void;
  saveAddressTwo: (customerAddressTwo: string) => void;
  saveCountry: (customercountry: string) => void;
  saveState: (customerstate: string) => void;
  saveCity: (customercity: string) => void;
  saveZipcode: (customerzipcode: string) => void;
  savePoc: (customerpoc: string) => void;
  savePocemail: (customerpocemail: string) => void;
  savePocphonenumber: (customerpocphonenumber: string) => void;
  saveProductportfolio: (customerproductportfolio: string) => void;
  saveDesignsoftware: (customerdesignsoftware: string) => void;
  saveVersionofsoftware: (customerversionofsoftware: string) => void;
  saveTrunaroundservice: (customerturnaroundservice: string) => void;
  savePreferenceform: (customerpreferenceform: File) => void;
  saveMaterialfiles: (customermaterialfiles: File, binaryData: ArrayBuffer, filename: string) => void;
  saveProduct: (customerProduct: string) => void;
  saveScanner: (customerScanner: string) => void;
  saveCommand: (customerCommand: string) => void;
  onSubmit: () => void;
  onLogin: () => void;

  customername: string;
  customertype: string;
  customerfirstname: string;
  contactPhonenumber: string;
  customeremail: string;
  // customerphonenumber: string;
  customeraddressone: string;
  customeraddresstwo: string;
  customercountry: string;
  customerstate: string;
  customerproduct: string;
  customerscanner: string;
  customercommand: string;
  customercity: string;
  customerzipcode: String;
  customerpoc: String;
  customerpocemail: String;
  customerpocphonenumber: String;
  customerproductportfolio: String;
  customerdesignsoftware: String;
  customerversionofsoftware: String;
  customerturnaroundservice: String;
  customerpreferenceform: File;
  customermaterialfiles: File;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
      height: '100vh'
    },
    container: {
      border: '1px solid',
      marginTop: '3%'
    },
    b: {
      color: 'red'
    },
    label: {
      fontSize: 'large',
      marginTop: '10px'
    },
    formControl: {
      margin: theme.spacing(1),
      minWidth: 300
    },
    selectEmpty: {
      marginTop: theme.spacing(2)
    },
    version: {
      display: 'flex',

    },
    paper: {
      marginTop: theme.spacing(2),
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
    },
    row: {
      display: 'flex',
      marginTop: '20px',
      alignItems: 'center'
    },
    avatar: {
      margin: theme.spacing(1),
      backgroundColor: theme.palette.secondary.main
    },
    cars: {
      padding: '20px 20px',
      backgroundColor: '#ffffff',
      border: '1px'
    },
    labelleft: {
      marginLeft: '10px'
    },
    form: {
      width: '100%', // Fix IE 11 issue.
    },
    textarea: {
      height: 10
    },
    forms: {
      width: '100%', // Fix IE 11 issue.
    },
    submit: {
      margin: theme.spacing(1, 0, 0),
      width: '30%',
      marginBottom: '15px',
    },
    buttom: {
      textAlign: 'center'
    },
    inpuWidgth: {
      marginLeft: '3%',
      width: '30%'
    },
    download: {
      backgroundColor: '#3f51b5',
      color: '#fff'
    }
  })
);

const SignUpPageView: React.StatelessComponent<SignUpPageViewProps> = props => {
  const classes = useStyles({});
  // const inputLabel = React.useRef<HTMLLabelElement>(null);
  // const inputLab = React.useRef<HTMLLabelElement>(null);
  // const inputCon = React.useRef<HTMLLabelElement>(null);
  // const [labelWidth, setLabelWidth] = React.useState(0);
  // const [lab, setLab] = React.useState(0);
  // const [con, setCon] = React.useState(0);
  // React.useEffect(() => {
  //   setLabelWidth(inputLabel.current!.offsetWidth);
  // });
  // React.useEffect(() => {
  //   setLab(inputLab.current!.offsetWidth);
  // });
  // React.useEffect(() => {
  //   setCon(inputCon.current!.offsetWidth);
  //   console.log(props, 'props');
  // });

  const [products, setProducts] = React.useState<string[]>([]);
  // const [design, setDesign] = React.useState<string[]>([]);

  const productChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;

    if (event.target.checked === true) {
      setProducts([...products, value]);
    } else {
      setProducts(products.filter((item) => item !== value));
    }
  };
  const productsportfolio = products.toString();
  props.saveProductportfolio(productsportfolio);

  // const designChange = (event: React.ChangeEvent<HTMLInputElement>) => {
  //   const value = event.target.value;

  //   if (event.target.checked === true) {
  //     setDesign([...design, value]);
  //   } else {
  //     setDesign(design.filter((item) => item !== value));
  //   }
  // };

  // var productsportfolio;
  // productsportfolio = products.toString();
  // console.log(productsportfolio, 'lllllllllllllllll');
  // props.saveProductportfolio('ganehs');

  interface Countryname {
    countryvalue: string;
  }
  interface Statename {
    statevalue: string;
  }

  const countryselect: Countryname[] = [
    { countryvalue: 'Canada' },
    { countryvalue: 'China' },
    { countryvalue: 'United States of America' },
  ];

  const canadastateselect: Statename[] = [
    { statevalue: 'Alberta' },
    { statevalue: 'Manitoba' },
  ];

  // const DownloadPdf = async () => {
  //   // const url = window.URL.createObjectURL(new Blob(['https://easydentconnect.com/admin/downloads/pricelist.pdf']));
  //   const url = window.URL.createObjectURL(new Blob(['https://democenter.in/dummyfiles/sample.pdf']));
  //   const filedownload = document.createElement('a');
  //   filedownload.style.display = 'none';
  //   filedownload.href = url;
  //   filedownload.download = 'https://democenter.in/dummyfiles/sample.pdf';
  //   document.body.appendChild(filedownload);
  //   filedownload.click();
  //   document.body.removeChild(filedownload);
  //   // window.open('https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf', '_blank');
  // };

  // const PreferencePdf = async () => {
  //   // const url = window.URL.createObjectURL(new Blob(['https://easydentconnect.com/admin/downloads/preference_form.xlsx']));
  //   const url = window.URL.createObjectURL(new Blob(['https://democenter.in/dummyfiles/sample.pdf']));

  //   const filedownload = document.createElement('a');
  //   filedownload.style.display = 'none';
  //   filedownload.href = url;
  //   filedownload.download = 'https://democenter.in/dummyfiles/sample.pdf';
  //   document.body.appendChild(filedownload);
  //   filedownload.click();
  //   document.body.removeChild(filedownload);
  //   // window.open('https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf', '_blank');
  // };

  return (
    <div className={classes.root}>
      <Header />
      <Container component="main" maxWidth="md" className={classes.container}>
        <CssBaseline />
        <div className={classes.paper}>
          <div className={classes?.header}>
            <h2>Sign Up to start working with EasyDent Design Centre</h2>
          </div>
          <div className={classes.card}>
            <form className={classes.form} noValidate>
              <Grid container spacing={2}>
                <Grid item xs={6} >
                  <div className={classes.row}>
                    <Grid item xs={3}>
                      <label>Name<b className={classes?.b}>*</b></label>
                    </Grid>
                    <Grid item xs={9}>
                      <TextField
                        size="small"
                        variant="outlined"
                        required
                        fullWidth
                        // label="Name"
                        autoFocus
                        onChange={event => props.saveCustomerName(event.target.value.trimLeft().replace(/\s+/g, ' '))}
                      // value={props.customername}
                      />
                    </Grid>
                  </div>
                </Grid>
                <Grid item xs={6} sm={6}>
                  <div className={classes.row}>
                    <Grid item xs={3}>
                      <label>Email ID<b className={classes?.b}>*</b></label>
                    </Grid>
                    <Grid item xs={9}>
                      <TextField
                        variant="outlined"
                        required
                        size="small"
                        fullWidth
                        type="email"
                        label="Email Address"
                        onChange={event => props.saveEmail(event.target.value.trimLeft().replace(/\s+/g, ' '))}
                      // value={props.customeremail}
                      />
                    </Grid>
                  </div>

                </Grid>
                {/* <Grid item xs={12} sm={12}>
                  <div>
                    <label className={classes.label}>Billing Address</label>
                  </div>
                </Grid> */}
                {/* address country --------------------------------------------------------------------------------------------------------  */}
                <Grid item xs={6} sm={6}>

                  <div className={classes?.row}>
                    <Grid item xs={3}>
                      <label>Address 1<b className={classes?.b}>*</b></label>
                    </Grid>
                    <Grid item xs={9}>
                      <TextField
                        variant="outlined"
                        required
                        fullWidth
                        size="small"
                        // label="Address 1"
                        onChange={event => props.saveAddressOne(event.target.value.trimLeft().replace(/\s+/g, ' '))}
                      // value={props.customerphonenumber}
                      />
                    </Grid>
                  </div>
                  <div className={classes?.row}>
                    <Grid item xs={3}>
                      <label>Address 2</label>
                    </Grid>
                    <Grid item xs={9}>
                      <TextField
                        variant="outlined"
                        required
                        fullWidth
                        size="small"
                        // label="Adress 2"
                        onChange={event => props.saveAddressTwo(event.target.value.trimLeft().replace(/\s+/g, ' '))}
                      // value={props.customerphonenumber}
                      />
                    </Grid>
                  </div>
                  <div className={classes?.row}>
                    <Grid item xs={3}>
                      <label>Country<b className={classes?.b}>*</b></label>
                    </Grid>
                    <Grid item xs={9}>
                      <FormControl size="small" variant="outlined" className={classes.forms}>
                        {/* <InputLabel ref={inputCon} htmlFor="outlined-age-native-simple">
                          Country
                        </InputLabel> */}
                        <Select
                          displayEmpty
                          value={props.customercountry || ''}
                          native
                          // labelWidth={con}
                          onChange={event => {
                            props.saveCountry(event.target.value as string);
                            props.saveState('');
                            props.saveCity('');
                          }}
                          inputProps={{
                            name: 'Country',
                            id: 'outlined-age-native-simple',
                          }}
                        // defaultValue={countryselect[2]}
                        >
                          <option selected value="" >Select the country</option>
                          {countryselect.map((item, index) => (
                            <option key={index}>{item.countryvalue}</option>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                  </div>
                </Grid>
                {/* sate city Zipcode------------------------------------------------------------------------- */}
                <Grid item xs={6} sm={6}>

                  <div className={classes?.row}>
                    <Grid item xs={3}>
                      <label>State<b className={classes?.b}>*</b></label>
                    </Grid>
                    <Grid item xs={9}>
                        <FormControl size="small" variant="outlined" className={classes.forms}>
                          <Select
                            native
                            displayEmpty
                            value={props.customerstate || ''}
                            onChange={event => {
                              props.saveState(event.target.value as string);
                              props.saveCity('');
                            }}
                            inputProps={{
                              name: 'state',
                              id: 'state-native-select',
                            }}
                          >
                            <option selected value="">Select the state</option>
                            {(props.customercountry === 'Canada') ? (
                              canadastateselect.map((state, index) => (
                                <option key={index}>{state.statevalue}</option>
                              ))
                            ) : (props.customercountry === 'China') ? (
                              <>
                                <option>Beijing</option>
                                <option>Shanghai</option>
                                <option>Zhejiang</option>
                              </>
                            ) : (props.customercountry === 'United States of America') && (
                              <>
                              <option>Alabama</option>
                              <option>Alaska</option>
                              <option>Arizona</option>
                              <option>Arkansas</option>
                              <option>California</option>
                              <option>Colorado</option>
                              <option>Connecticut</option>
                              <option value="Delaware">Delaware</option>
                              <option value="District of Columbia">District of Columbia</option>
                              <option value="Florida">Florida</option>
                              <option value="Georgia">Georgia</option>
                              <option value="Hawaii">Hawaii</option>
                              <option value="Idaho">Idaho</option>
                              <option value="Illinois">Illinois</option>
                              <option value="Indiana">Indiana</option>
                              <option value="Iowa">Iowa</option>
                              <option value="Kansas">Kansas</option>
                              <option value="Kentucky">Kentucky</option>
                              <option value="Louisiana">Louisiana</option>
                              <option value="Maine">Maine</option>
                              <option value="Maryland">Maryland</option>
                              <option value="Massachusetts">Massachusetts</option>
                              <option value="Michigan">Michigan</option>
                              <option value="Minnesota">Minnesota</option>
                              <option value="Mississippi">Mississippi</option>
                              <option value="Missouri">Missouri</option>
                              <option value="Montana">Montana</option>
                              <option value="Nebraska">Nebraska</option>
                              <option value="Nevada">Nevada</option>
                              <option value="New Hampshire">New Hampshire</option>
                              <option value="New Jersey">New Jersey</option>
                              <option value="New Mexico">New Mexico</option>
                              <option value="New York">New York</option>
                              <option value="North Carolina">North Carolina</option>
                              <option value="North Dakota">North Dakota</option>
                              <option value="Ohio">Ohio</option>
                              <option value="Oklahoma">Oklahoma</option>
                              <option value="Oregon">Oregon</option>
                              <option value="Pennsylvania">Pennsylvania</option>
                              <option value="Puerto Rico">Puerto Rico</option>
                              <option value="Rhode Island">Rhode Island</option>
                              <option value="South Carolina">South Carolina</option>
                              <option value="South Dakota">South Dakota</option>
                              <option value="Tennessee">Tennessee</option>
                              <option value="Texas">Texas</option>
                              <option value="Utah">Utah</option>
                              <option value="Vermont">Vermont</option>
                              <option value="Virgin Islands">Virgin Islands</option>
                              <option value="Virginia">Virginia</option>
                              <option value="Washington">Washington</option>
                              <option value="West Virginia">West Virginia</option>
                              <option value="Wisconsin">Wisconsin</option>
                              <option value="Wyoming">Wyoming</option>
                            </>
                            )}
                          </Select>
                        </FormControl>
                    </Grid>
                  </div>
                  <div className={classes?.row}>
                    <Grid item xs={3}>
                      <label>City<b className={classes?.b}>*</b></label>
                    </Grid>
                    <Grid item xs={9}>
                      <FormControl size="small" variant="outlined" className={classes.forms}>
                        {(props.customercountry !== 'United States of America') ? (
                          <Select
                            native
                            displayEmpty
                            value={props.customercity || ''}
                            // labelWidth={con}
                            onChange={event => props.saveCity(event.target.value as string)}
                            inputProps={{
                              name: 'City',
                              id: 'outlined-age-native-simple',
                            }}
                          >
                            <option selected value="" >Select the city</option>
                            {(props.customerstate === 'Alberta') ? (
                              <option>Calgary</option>
                            ) :
                              (props.customerstate === 'Manitoba') ?
                                (
                                  <option>Brandon</option>
                                ) :

                                (props.customerstate === 'Beijing') ?
                                  (
                                    <option>Beijing</option>
                                  ) :
                                  (props.customerstate === 'Shanghai') ?
                                    (
                                      <option>Shanghai</option>
                                    ) :
                                    (props.customerstate === 'Zhejiang') ?
                                      (
                                        <option>Hangzhou</option>
                                      ) :
                                      (
                                        <></>
                                      )
                            }
                          </Select>
                        ) :
                          (
                            <TextField
                              variant="outlined"
                              required
                              size="small"
                              fullWidth
                              onChange={event => props.saveCity(event.target.value as string)}
                            />
                          )}
                      </FormControl>
                    </Grid>
                  </div>
                  <div className={classes?.row}>
                    <Grid item xs={3}>
                      <label>Zip Code<b className={classes?.b}>*</b></label>
                    </Grid>
                    <Grid item xs={9}>
                      <TextField
                        variant="outlined"
                        required
                        size="small"
                        fullWidth
                        onKeyDown={(e) => {
                          if (['e', 'E', '+', '-'].includes(e.key)) {
                             e.preventDefault();
                          }
                        }}
                        type="number"
                        // inputProps={{ inputMode: 'numeric' }}
                        onChange={event => props.saveZipcode(event.target.value.trimLeft().replace(/\s+/g, ' ') as string)}
                      // value={props.customeremail}
                      />
                    </Grid>
                  </div>

                </Grid>
                <Grid item xs={12} sm={12}>
                  <div className={classes?.row}>
                    <Grid item xs={3}>
                      <label>Point of Contact (POC)<b className={classes?.b}>*</b></label>
                    </Grid>
                    <Grid item xs={9}>
                      <TextField
                        variant="outlined"
                        required
                        size="small"
                        fullWidth
                        onChange={event => props.savePoc(event.target.value.trimLeft().replace(/\s+/g, ' ') as string)}
                      // value={props.customeremail}
                      />
                    </Grid>
                  </div>
                  <div className={classes?.row}>
                    <Grid item xs={3}>
                      <label>Email ID (POC)<b className={classes?.b}>*</b></label>
                    </Grid>
                    <Grid item xs={3}>
                      <TextField
                        variant="outlined"
                        required
                        size="small"
                        fullWidth
                        type="email"
                        onChange={event => props.savePocemail(event.target.value.trimLeft().replace(/\s+/g, ' ') as string)}
                      // value={props.customeremail}
                      />
                    </Grid>
                    <Grid item xs={3}>
                      <label className={classes?.labelleft}>Contact No. (POC)<b className={classes?.b}>*</b></label>
                    </Grid>
                    <Grid item xs={3}>
                      <TextField
                        variant="outlined"
                        required
                        size="small"
                        fullWidth
                        type="number"
                        onKeyDown={(e) => {
                          if (['e', 'E', '-'].includes(e.key)) {
                             e.preventDefault();
                          }
                        }}
                        onChange={event => props.savePocphonenumber(event.target.value.trimLeft().replace(/\s+/g, ' ') as string)}
                      // value={props.customeremail}
                      />
                    </Grid>
                  </div>
                  <div className={classes?.row}>
                    <Grid item xs={3}>
                      <label>Product Portfolio<b className={classes?.b}>*</b></label>
                    </Grid>
                    <Grid item xs={9}>
                      <Checkbox
                        size="small"
                        value={'Fixed Prosthesis'}
                        onChange={(e) => productChange(e)}
                      />
                      <label>Fixed Prosthesis</label>
                      <Checkbox
                        size="small"
                        value={'Implant Prosthesis'}
                        onChange={(e) => productChange(e)}
                      />
                      <label>Implant Prosthesis</label>
                      <Checkbox
                        size="small"
                        value={'Removable Prosthesis'}
                        onChange={(e) => productChange(e)}
                      />
                      <label>Removable Prosthesis</label>
                      <Checkbox
                        size="small"
                        value={'Bravo'}
                        onChange={(e) => productChange(e)}
                      />
                      <label>Bravo</label>
                    </Grid>
                  </div>
                  <div className={classes?.row}>

                    <Grid item xs={3}>
                      <label>Preferred design software<b className={classes?.b}>*</b></label>
                    </Grid>
                    <Grid item xs={3}>
                      <Select
                        native
                        // labelWidth={con}
                        onChange={event => props.saveDesignsoftware(event.target.value as string)}
                      >
                        <option selected hidden>Select</option>
                        <option value={'3Shape'} >3Shape</option>
                        <option value={'Exocad'}>Exocad</option>
                      </Select>
                    </Grid>
                    <Grid item xs={3}>
                      <label>Preferred Turnaround Service<b className={classes?.b}>*</b></label>
                    </Grid>
                    <Grid item xs={3}>
                      <Select
                        native
                        // labelWidth={con}
                        onChange={event => props.saveTrunaroundservice(event.target.value as string)}
                      >
                        <option selected hidden>Select</option>
                        <option value={'Next Day/24 Hours'} >Next Day/24 Hours</option>
                        <option value={'Rush/2-3 Hours'}>Rush/2-3 Hours</option>
                        <option value={'Same Day/6-8 Hours'}>Same Day/6-8 Hours</option>
                      </Select>

                    </Grid>

                  </div>
                  <div className={classes?.row}>
                    <Grid item xs={3}>
                      <label>Version of Software <b className={classes?.b}>*</b></label>
                    </Grid>
                    <Grid item xs={9}>
                      <TextField
                        variant="outlined"
                        required
                        size="small"
                        fullWidth
                        inputProps={{ maxLength: 10 }}
                        onChange={event => props.saveVersionofsoftware(event.target.value.trimLeft().replace(/\s+/g, ' ') as string)}
                      />
                    </Grid>

                  </div>
                  {/* <div className={classes?.row}>
                    <Grid item xs={3}>
                      <label>Preference Form<b className={classes?.b}>*</b></label>
                    </Grid>
                    <Grid item xs={4}>
                      <Button onClick={PreferencePdf} className={classes.download}>Download</Button>
                    </Grid>
                    <Grid item xs={5}>
                      <input
                        type="file"
                        id="file-input"
                        onChange={event => {
                          const selectedFile = event.target.files && event.target.files[0];
                          if (selectedFile) {
                            props.savePreferenceform(selectedFile);
                          }
                        }}
                      />
                    </Grid>
                  </div> */}
                  {/* <div className={classes?.row}>
                    <Grid item xs={3}>
                      <label>Material Files (DME)</label>
                    </Grid>
                    <Grid item xs={9}>
                      <input
                        type="file"
                        id="file-input"
                        // onChange={event => {
                        //   const selectedFile = event.target.files && event.target.files[0];
                        //   if (selectedFile) {
                        //     props.saveMaterialfiles(selectedFile);
                        //   }
                        // }}

                        onChange={event => {
                          const selectedFile = event.target.files && event.target.files[0];
                          // Create a unique file name
                          const randomNumber = Math.floor(Math.random() * 100000);
                          // Get the current date and time
                          const currentDateTime = new Date().toISOString().replace(/[:.]/g, '-');
                          const filename = `${currentDateTime}_file_${randomNumber}_${selectedFile?.name}`;

                          console.log(selectedFile?.name, 'file');
                          if (selectedFile) {
                            const reader = new FileReader();

                            reader.onload = (e: ProgressEvent<FileReader>) => { // Specify the type for e
                              if (e.target) {
                                // The binary data is available in e.target.result
                                const binaryData = e.target.result as ArrayBuffer;

                                console.log(binaryData, 'materialFIle');

                                // Now you can pass both selectedFile and binaryData to your function.
                                props.saveMaterialfiles(selectedFile, binaryData, filename);
                              }
                            };

                            // Read the selectedFile as binary data
                            reader.readAsArrayBuffer(selectedFile);
                          }
                        }}
                      />
                    </Grid>
                  </div> */}
                  {/* <div className={classes?.row}>
                    <Grid item xs={3}>
                      <label>Price List</label>
                    </Grid>
                    <Grid item xs={9}>
                      <Button onClick={DownloadPdf} className={classes.download}>Download</Button>
                    </Grid>

                  </div> */}
                  {/* <Grid xs={12}>
                    <div className={classes?.row}>
                      <Grid item xs={3}>
                        <label>Billing Cycle<b className={classes?.b}>*</b></label>
                      </Grid>
                      <Grid item xs={9}>
                        <Checkbox
                          size="small"
                        />
                        <label>7 Days</label>
                        <Checkbox
                          size="small"
                        />
                        <label>15 Days</label>
                      </Grid>
                    </div>
                  </Grid>
                  <Grid xs={12}>
                    <div className={classes?.row}>
                      <Grid item xs={3}>
                        <label>Billing Poc<b className={classes?.b}>*</b></label>
                      </Grid>
                      <Grid item xs={9}>
                        <TextField
                          variant="outlined"
                          required
                          size="small"
                          fullWidth

                          onChange={event => props.saveEmail(event.target.value)}
                          value={props.customeremail}
                        />
                      </Grid>
                    </div>
                  </Grid>
                  <Grid xs={12}>
                    <div className={classes?.row}>
                      <Grid item xs={3}>
                        <label>Email ID (Billing Poc)<b className={classes?.b}>*</b></label>
                      </Grid>
                      <Grid item xs={3}>
                        <TextField
                          variant="outlined"
                          required
                          size="small"
                          fullWidth

                          onChange={event => props.saveEmail(event.target.value)}
                          value={props.customeremail}
                        />
                      </Grid>
                      <Grid item xs={3}>
                        <label className={classes?.labelleft}>Contact NO. (Billing Poc)<b className={classes?.b}>*</b></label>
                      </Grid>
                      <Grid item xs={3}>
                        <TextField
                          variant="outlined"
                          required
                          size="small"
                          fullWidth

                          onChange={event => props.saveEmail(event.target.value)}
                          value={props.customeremail}
                        />
                      </Grid>
                    </div>
                  </Grid> */}
                  {/* <Grid xs={12}>
                    <div className={classes?.row}>
                      <Grid item xs={3}>
                        <label>Terms & Conditions<b className={classes?.b}>*</b></label>
                      </Grid>
                      <Grid item xs={3}>
                        <Button>Download</Button>
                      </Grid>
                      <Grid item xs={3}>
                        <input
                          type="file"
                          id="file-input"
                        />
                      </Grid>
                    
                    </div>
                  </Grid> */}
                </Grid>
              </Grid>
              <div className={classes?.buttom}>
                <Button
                  type="button"
                  fullWidth
                  variant="contained"
                  color="primary"
                  className={classes.submit}
                  onClick={props.onSubmit}
                >
                  Sign UP
                </Button>
              </div>
              <Hidden smUp>
                <Grid item>
                  <Link to={'/login'}>Sign In</Link>
                </Grid>
              </Hidden>
            </form>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default SignUpPageView;



// WEBPACK FOOTER //
// ./src/components/layouts/SignUpPageView.tsx